import { WarningModel } from '@/services/warnings/warningDefinitions';
import { FC } from 'react';

interface WarningsProps {
  warnings: WarningModel[];
}

export const WarningsList: FC<WarningsProps> = ({ warnings }) => {
  return (
    <div className="text-sm">
      <div className="space-y-2">
        {warnings.map((warning: WarningModel, index: number) => (
          <div key={'warning-' + index}>
            <div className="font-semibold">{warning.name}</div>
            {warning?.details?.map((detail: string, index: number) => (
              <div className="pl-3" key={'detail-' + index}>
                {`- ${detail}`}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
